import store from 'store'

export default router => {
  router.beforeEach((to, from, next) => {
    const auth = to.meta.auth
    // console.log(auth)
    if (auth === 'guest') {
      if (store.getters['auth/authenticated'] === false) {
        next()
      } else {
        next({ name: 'azienda' })
      }

      return
    }

    if (auth === 'app') {
      if (store.getters['auth/setToken']) {
        next()
      } else {
        next({ name: 'welcome' })
      }

      return
    }

    next()
  })
}

/*
export default router => {
  router.beforeEach((to, from, next) => {
    const auth = to.meta.auth
    // console.log(auth)
    if (auth === 'guest') {
      if (store.getters['auth/authenticated'] === false) {
        next()
      } else {
        next({ name: 'dashboard' })
      }

      return
    }

    if (auth === 'app') {
      if (store.getters['auth/setToken']) {
        next()
      } else {
        next({ name: 'welcome' })
      }

      return
    }

    next()
  })
} */
